import { render, staticRenderFns } from "./CurrentPageMenuComponent.vue?vue&type=template&id=cee343d0"
import script from "./CurrentPageMenuComponent.vue?vue&type=script&lang=js"
export * from "./CurrentPageMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports